<template>
  <div
    v-if="!auth.isLoggedIn && !dismissed"
    class="w-full bg-[#111] text-white border-b border-white/8"
  >
    <!-- Gele accentlijn bovenaan (zelfde als footer) -->
    <div class="h-[2px] w-full bg-gradient-to-r from-[#FFD500] via-[#FFB800] to-[#FFD500]"></div>

    <div class="max-w-screen-xl mx-auto px-4 sm:px-6 py-2.5 sm:py-3.5">
      <!-- Desktop: één rij -->
      <div class="hidden sm:flex items-center justify-between gap-6">
        <div class="flex items-center gap-3 flex-1 min-w-0">
          <i class="bi bi-person-badge text-brand text-[1.15rem] shrink-0" aria-hidden="true"></i>
          <div>
            <p class="font-semibold text-[0.9rem] leading-snug">
              Ben je een installateur? Log in voor installateurskorting en toegang tot onze configurators.
            </p>
            <p class="text-white/50 text-[0.8rem] mt-0.5">
              Je bekijkt nu de doe-het-zelver prijzen. Als doe-het-zelver kun je ook als gast afrekenen.
            </p>
          </div>
        </div>
        <div class="flex items-center gap-2.5 shrink-0">
          <router-link to="/account?tab=login" @click="track('installateur_banner_login_click')"
            class="border border-white/20 text-white/80 hover:border-white/50 hover:text-white px-4 py-1.5 rounded text-[0.82rem] font-semibold transition-colors no-underline whitespace-nowrap">
            Inloggen
          </router-link>
          <router-link to="/account?tab=register" @click="track('installateur_banner_register_click')"
            class="bg-brand text-ink hover:bg-[#FFB800] px-4 py-1.5 rounded text-[0.82rem] font-bold transition-colors no-underline whitespace-nowrap">
            Gratis aanmelden
          </router-link>
          <button @click="dismiss" class="text-white/30 hover:text-white/70 transition-colors ml-0.5 p-1" aria-label="Sluiten">
            <i class="bi bi-x text-base"></i>
          </button>
        </div>
      </div>

      <!-- Mobiel: compacte versie -->
      <div class="flex sm:hidden items-center gap-3">
        <i class="bi bi-person-badge text-brand text-[1rem] shrink-0" aria-hidden="true"></i>
        <p class="flex-1 min-w-0 text-[0.78rem] font-semibold leading-snug">
          Installateur? <span class="text-white/60 font-normal">Meld je aan voor korting.</span>
        </p>
        <router-link to="/account?tab=register" @click="track('installateur_banner_register_click')"
          class="bg-brand text-ink hover:bg-[#FFB800] px-3 py-1.5 rounded text-[0.75rem] font-bold transition-colors no-underline whitespace-nowrap shrink-0">
          Aanmelden
        </router-link>
        <button @click="dismiss" class="text-white/30 hover:text-white/70 transition-colors p-1 shrink-0" aria-label="Sluiten">
          <i class="bi bi-x text-base"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@stores/auth'

const auth = useAuthStore()
const dismissed = ref(false)
const STORAGE_KEY = 'p2c_installateur_banner_dismissed'

// SSR-veilig: onthoud of de bezoeker de banner eerder heeft gesloten.
onMounted(() => {
  try {
    if (localStorage.getItem(STORAGE_KEY) === '1') dismissed.value = true
  } catch (e) { /* noop */ }
})

// Fire a GA4 event (gtag is loaded globally via index.html)
const track = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      event_category: 'installateur_banner',
      ...params
    })
  }
}

const dismiss = () => {
  track('installateur_banner_dismissed')
  dismissed.value = true
  try { localStorage.setItem(STORAGE_KEY, '1') } catch (e) { /* noop */ }
}
</script>
